import React, { FunctionComponent } from 'react';
import * as styles from './Highlights.style';

export interface HighlightsProps {
  items: string[],
}

const Highlights: FunctionComponent<HighlightsProps> = ({ items }) => (
  <div css={styles.highlights}>
    {items.map((item) => (
      <span
        key={item}
        dangerouslySetInnerHTML={{ __html: item }}
        data-ref="highlight"
      />
    ))}
  </div>
);

export default Highlights;
